<div class="table-header-content" [class.required-mark]="isRequired">
    <span (click)="onSortingChange()"> {{label}}</span>
    <span *ngIf="sortModel" class="sorting">
        <i class="fa" [ngClass]="{ 
            'fa-sort' : sortModel.column != key,
            'fa-sort-up' : sortModel.column == key && !sortModel.isDescending,
            'fa-sort-down' : sortModel.column == key && sortModel.isDescending === true
        }">
        </i>        
    </span>
</div>